import React, { useState } from 'react'
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const Video = (props) => {

    const [isOpenVideo, setIsOpenVideo] = useState(false);

    const { styles, header, url } = props

    const showModalVideo = () => {
        setIsOpenVideo(true);
    };

    const hideModalVideo = () => {
        setIsOpenVideo(false);
    };

    const videoHeader = (
        <div>
            <h3>{header}</h3>
        </div>
    )

    return (
        <>
            <Dialog header={videoHeader} visible={isOpenVideo} position="top" draggable={false} resizable={false} modal onHide={hideModalVideo}
                style={{
                    width: "60%"
                }}
            >
                <iframe
                    width="90%"
                    height="480"
                    src={url}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    title="Embedded youtube"
                />
            </Dialog>

            <Button
                onClick={showModalVideo}
                icon="pi pi-youtube text-2xl text-red-400"
                className="icon p-button-rounded p-button-text text-red-400"
                style={{ ...styles, height: "1rem", width: "1.8rem", marginLeft: "0.1rem", marginTop: "0.2rem", fontSize: "4rem", color: "red" }}
                tooltip='Click en este ícono para acceder al instructivo este proceso'
                tooltipOptions={{
                    style: { marginLeft: "1rem" }
                }}
            />
        </>
    )
}

export default Video
